import React, { Component } from "react";
import {Container,Row,Col,Button, Form, FormGroup, Label, Input ,Modal,ModalBody,DropdownItem,DropdownMenu,UncontrolledDropdown,DropdownToggle } from 'reactstrap';
import httpClient from "../../../httpClient";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faAngleDown, faAngleLeft, faAngleRight,faPlus, faTimes
 } from '@fortawesome/free-solid-svg-icons'
import data from '../../data/data.json'
 import { connect } from 'react-redux';
import { addTransfert,addCarPhotos,addCar } from "../../../slices/modalSlice";
import { Divider } from "semantic-ui-react";



class AddTransfertAnnounce extends Component {
    constructor(props) {
        super(props);
        this.state = {
          announceCarInfo: {
            title: "",
            typeTransf : "Collectif",
            nbrSiege : 4,
            pays: "Algérie",
            region: "Alger",
            commune: "Bab El Oued",
            marque: "Renault",
            modele: "Clio",
            energie: "Diesel",
            annee: "2020",
            options: [],
            type:"Citadine",
            infoComplementaire: "",
            files : [],
            parCrs: { prix: 500, currancy: "DZD", fraisSupp: 100 },
            parKm: {
              prix: 1000,
              currancy: "DZD",
              fraisSupp: 100,
            },
            parPers: {
              prix: 1500,
              currancy: "DZD",
              fraisSupp: 100,
            },
          },
          openImagCar : false,
          availableCities: [],
          availableDairas: [],
          wilayaId: 15,
          imgUrl:[],
          alertMaxPic : false,
        };
         this.getData_dropDown = this.getData_dropDown.bind(this)
         this.toogleClosePhotos = this.toogleClosePhotos.bind(this);   

    }

    toogleClosePhotos =()=> this.props.dispatch(addCarPhotos())

    onInputChange(evt) {
      //if checkbox or input txt,num....
        if(evt.target.type !== "checkbox"){
          let name = evt.target.name
          let timeUnit =  evt.target.attributes.data || {value : ""}
          //we need to update object include in object
          if (timeUnit.value === "parJrs" || timeUnit.value === "parSemaine"|| timeUnit.value === "parMois") {
            this.setState({
              announceCarInfo: {
                  ...this.state.announceCarInfo,
                  [timeUnit.value]: {
                     ...this.state.announceCarInfo[timeUnit.value],
                     [name]: evt.target.value

                  }
              }
            })
          }else
          this.setState({
            announceCarInfo: {
                ...this.state.announceCarInfo,
                [name]: evt.target.value
            }
          })
        }
        else if(evt.target.type === "checkbox" ){
          const value = evt.target.nextSibling.data;
          this.setState({
            announceCarInfo: {
                  ...this.state.announceCarInfo,
                  options: [...this.state.announceCarInfo.options,value.replaceAll(' ',"+")]
              }
              })
        }}
          
          toogleClose = () =>{
            this
            .props
            .dispatch(addTransfert())
          }
      

          postAnnounceCar(evt){
            evt.preventDefault()
            const idOwner = this.props.ownerId
            const typeAnnounce = "Voiture"
            const files = this.state.announceCarInfo.files
            httpClient.createCarAnnouce(this.state.announceCarInfo,idOwner,typeAnnounce,files).then(sent => {
              if (sent) {
                this.toogleClose();
                this.props.dispatch(addCarPhotos());
                this.setState({ announceCarInfo: {title: '', pays:"Algeriee" , region:"Alger", commune:"", marque:"Renault", modele:"Clio", energie:"Diesel", type:"4x4", transmission:"", annee:"", kilometrage:"", couleur:"", nbrPortes:4,nbrSiege:4, options:[], infoComplementaire:"",
                    parJrs:{prix:500,currancy:"DZD",distMAx:10,fraisSupp:100},
                    parSemaine:{prix:1000,currancy:"DZD",distMAx:10,fraisSupp:100},
                    parMois:{prix:1500,currancy:"DZD",distMAx:10,fraisSupp:100},
                }
                  })
              }
              else
               alert('Error')

                
                  })
        }

        getData_dropDown(e,wilaya,id){
            e.preventDefault()
            this.setState({
                announceCarInfo: {
                ...this.state.announceCarInfo,
                [e.currentTarget.name]: wilaya || e.currentTarget.textContent
              },
              wilayaId:id||this.state.wilayaId
            }); 
          }

          onChangeUpload(e) {
            if (this.state.imgUrl.length<=4) {
              this.setState({files:e.target.files[0]});
           e.preventDefault();
        
           const file =  e.target.files[0]
        
           this.setState({
            announceCarInfo: {
              ...this.state.announceCarInfo,
              files: [...this.state.announceCarInfo.files,file]
          }
        })
        
           const fileReader = new FileReader();
           fileReader.onload = () => {
           this.setState({imgUrl: [...this.state.imgUrl,fileReader.result]});
           }
           fileReader.readAsDataURL(file);
          }
        
            else(
              this.setState({
                alertMaxPic : true
              })
            )
        }
           


    render() {
      const carType = ["Mini Citadine","Citadine","Berline","Moyenne Berline","SUV Tout-terrain","Grande Berline","Break Familliale","Coupé Cabriolet","Van","Mini Bus","Bus / Navette"]
      const carTypeeElm = [];
      const transfTypeElm = [];
      const restitution = ["Restitution dans un endroit différent","Sans Chauffeur seulement","avec Chaufeur seulement","Conducteur entre 30 et 65 ans"]
      const restitutionElm = [];
      const transfTypes = ["Collectif", "Individuel"]
      

      carType.forEach(elm =>{
        carTypeeElm.push(
          <DropdownItem name="type" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>{elm}</DropdownItem>
          )
        })
      transfTypes.forEach(elm =>{
          transfTypeElm.push(
            <DropdownItem name="type" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>{elm}</DropdownItem>
            )
          })
      restitution.forEach(elm=>{
          restitutionElm.push(
            <DropdownItem name="annulation" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>{elm}</DropdownItem>
            )
        })
      const wilayaNameItem = data.wilayas.map(function(item, i){
        return (
          <DropdownItem name="region" onClick={e=>this.getData_dropDown(e,item.name,i)}> <span>{i+1}</span> {item.name}</DropdownItem>
        )
        },this)

        const transfType = transfTypes.map(function(item, i){
          return (
            <DropdownItem name="region" onClick={e=>this.getData_dropDown(e,item.name,i)}>  {item.name}</DropdownItem>
          )
          },this)

        const dairasNameItem = data.wilayas[this.state.wilayaId].dairas.map(function(item, i){
          return (
            <DropdownItem name="commune" onClick={e=>this.getData_dropDown(e,item.name,i)}> <span>{i+1}</span> {item.name}</DropdownItem>
            )
          },this)


          const imag0 = this.state.imgUrl[0]
          const imag1 = this.state.imgUrl[1]
          const imag2 = this.state.imgUrl[2]
          const imag3 = this.state.imgUrl[3]
          const imag4 = this.state.imgUrl[4]

        const {title,typeTransf, pays , region, commune, marque, modele, energie, type, annee,nbrSiege, infoComplementaire,parCrs,parKm,parPers } = this.state.announceCarInfo
        return ( 
          <>
            <Modal isOpen={this.props.addTransfert}  className="modal-width-details-announce">
            <nav className="nav-windows-addanounce">
            <button className="close-heberg"  onClick={this.toogleClose} >
              <span><FontAwesomeIcon icon={faTimes}/></span>
            </button>
            <div className="title-announce" >
            Nouvelle Annonce - Transfert de Voyageurs
            </div>
            </nav>
            <div className="path-add-announce"></div>
            <ModalBody>
         
                <Container>
                  <div className="custom-container">
                  <Form onChange={this.onInputChange.bind(this)} onSubmit={this.postAnnounceCar.bind(this)}>
                    <div className="segment__head mb-4">
                        <h4 className="segment__head__txt">Informations de Base</h4>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                       <div  className="second-Rw d-flex align-items-center col-12 px-0 mr-2">
                        <span className="mr-2">Titre</span>
                        <Input type="text" name="title" placeholder="Donnez un titre a votre annonce" className="title-announce-input" value={title} required></Input>
                       </div> 
                    </div>
                    <div className="d-flex align-items-center mb-3">
                        <UncontrolledDropdown nav className="col-4 mr-4 px-0 d-flex align-items-center">
                         <span className="text-nowrap mr-2">Type de transfert</span>
                         <DropdownToggle className="button-add-pays title-announce-input">
                          {typeTransf}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                            {transfTypeElm}

                          </DropdownMenu>
                        </UncontrolledDropdown> 
                        <UncontrolledDropdown nav className="col-4 mr-4 px-0 d-flex align-items-center">
                         <span className="text-nowrap mr-2">Type de véhicule</span>
                         <DropdownToggle className="button-add-pays title-announce-input">
                         {type}
                            <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                          </DropdownToggle>
                          <DropdownMenu right className="full-width">
                          {carTypeeElm}
                          </DropdownMenu>
                        </UncontrolledDropdown> 
                        <div className="d-flex align-items-center">
                          <label htmlFor="nbrAdulte">Sièges </label>
                          <input type="number"  min="1" defaultValue = "1" className="number-input-announce" name="sgDispo" value={this.state.sgDispo}/>
                          
                        </div>
                    </div>
                    
  
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <Row>
                        <Col sm="2" id="label-title-input"><label>Pays</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {pays}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px",overflowY: "scroll" }}>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="4">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Region</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {region}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px",overflowY: "scroll" }}>
                            {wilayaNameItem}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col> 
  
                      <Col sm="5">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Commune</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {commune}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right style={{ maxHeight: "280px",overflowY: "scroll" }}>
                              {dairasNameItem}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                    </Row>
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Marque</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {marque}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Renault</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Mercedes</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Peugeot</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>BMW</DropdownItem>
                              <DropdownItem name="marque" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Volswagen</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Modéle</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            {modele}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="modele" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Octavia</DropdownItem>
                              <DropdownItem name="modele" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Clio3</DropdownItem>
                              <DropdownItem name="modele" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>AMG</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Energie</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           {energie}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="energie" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Essence</DropdownItem>
                              <DropdownItem name="energie" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Diesel</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col> 
  
                      <Col sm="3">
                        <Row>
                        <Col sm="3" id="label-title-input"><label>Année</label></Col>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-announce">
                           2015
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                             
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                      </Col>
  
                    </Row>
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <div className="d-flex align-items-center">
                         <label>Point de départ</label>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            Ville
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Manuel</DropdownItem>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Automatique</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </div>
                      </Col>
  
 
                        <Row>
  
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            commune
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2012</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2013</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2014</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2015</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2016</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2017</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2018</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2019</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2020</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2021</DropdownItem>


                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                   
  
                        <div className="d-flex align-items-center col">
                          <label htmlFor="nbrAdulte" className="mr-2 text-nowrap">Lien google maps</label>
                          <Input type="text" className="title-announce-input" placeholder="https://www.maps.com/.."  value={this.state.sgDispo}/>
                          
                        </div>
  
                    </Row>
  
  
                    <Row   className="second-Row">
                      <Col sm="3">
                        <div className="d-flex align-items-center">
                         <label>Vers</label>
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            Aéroport
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Manuel</DropdownItem>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Automatique</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </div>
                      </Col>
  
 
                        <Row>
  
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            Ville
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2012</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2013</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2014</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2015</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2016</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2017</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2018</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2019</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2020</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2021</DropdownItem>


                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                        <Row>
  
                         <Col>
                         <UncontrolledDropdown nav >
                           <DropdownToggle className="button-add-pays title-announce-input">
                            Commune
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2012</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2013</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2014</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2015</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2016</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2017</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2018</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2019</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2020</DropdownItem>
                              <DropdownItem name="annee" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>2021</DropdownItem>


                            </DropdownMenu>
                          </UncontrolledDropdown>
                         </Col>
                        </Row>
                   
  
                        <div className="d-flex align-items-center col">
                          <label htmlFor="nbrAdulte" className="mr-2 text-nowrap">Lien google maps</label>
                          <Input type="text" className="title-announce-input" placeholder="https://www.maps.com/.."  value={this.state.sgDispo}/>
                          
                        </div>
  
                    </Row>
                    <div className="segment__head mb-4">
                        <h4 className="segment__head__txt">Equipements</h4>
                    </div>
  
                    <div className="second-Row d-flex">
  
                      <Col sm="3" className="column-equipement px-0">
                      <FormGroup check className="check-box form-check-equipement text-nowrap"><Label check><Input type="checkbox" />Porte Bagage Supplém.</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement text-nowrap"><Label check><Input type="checkbox" />Passagers à mobilité réduite</Label></FormGroup>
                      </Col>
  
                      <Col sm="3" className="column-equipement px-0">
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Climatisation</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Prises USB</Label></FormGroup>
                      </Col>
  
                      <Col sm="3" className="column-equipement px-0">
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Chauffage</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Véhicule VIP</Label></FormGroup>
                      </Col>
                      <Col sm="3" className="column-equipement px-0">
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Siège Bébé</Label></FormGroup>
                      <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />GPS</Label></FormGroup>
                      </Col>
  
                    </div>
  
                    <Row   className="second-Row">
                     <Col sm="3" id="label-title-input"><label>Information complémentaires</label></Col>
                     <Col ><Input type="textarea" name="infoComplementaire" placeholder="Equipement non-cités" className="text-area-descr" value={infoComplementaire} required></Input></Col>
                    </Row>
  
                    <div className="segment__head mb-4">
                        <h4 className="segment__head__txt">Tarification</h4>
                    </div>
  
                    <Row className="second-Row">
                    <Col sm="2"><label>Prix</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parJrs" name="prix" value={parCrs.prix} required/></Col>
                    <Col sm="4">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-prix-announce">
                           {parCrs.currancy}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>DZD</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>EUR</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>US</DropdownItem>
                            </DropdownMenu>
                           <span className="ml-2">/Course</span>
                          </UncontrolledDropdown>
                      </Col>
                      
                      <Col sm="6">
                        <label>Frais Supp</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data='parJrs' name="fraisSupp" value={parKm.fraisSupp} required/><span className="ml-2">/Minute</span>
                      </Col>
                    </Row>
  
                    <Row className="second-Row">
                    <Col sm="2"><label>Prix</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" name="prix" data="parSemaine" value={parKm.prix} required/></Col>
                    <Col sm="4">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-prix-announce">
                           {parKm.currancy}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>DZD</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>EUR</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>US</DropdownItem>
                            </DropdownMenu>
                            <span className="ml-2">/Km</span>
                          </UncontrolledDropdown>
                      </Col>
                   
                      <Col sm="6">
                        <label>Frais Supp</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parSemaine" name="fraisSupp" value={parKm.fraisSupp} required/><span className="ml-2">/Km</span>
                      </Col>
                    </Row>
  
                    <Row className="second-Row">
                    <Col sm="2"><label>Prix</label><input type="number" min="1" defaultValue = "1"  className="price-input-announce" data="parMois" name="prix" value={parPers.prix} required/></Col>
                    <Col sm="4">
                      <UncontrolledDropdown nav >
                           <DropdownToggle className="button-prix-announce">
                           {parPers.currancy}
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>DZD</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>EUR</DropdownItem>
                              <DropdownItem  name="currency" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>US</DropdownItem>
                            </DropdownMenu>
                            <span className="ml-2">/Personne</span>
                          </UncontrolledDropdown>
                      </Col>
                     
                      <Col sm="6">
                      <UncontrolledDropdown nav  className="d-flex align-items-center">
                          <span className="mr-2">Annulation</span>
                           <DropdownToggle className="button-add-pays title-announce-input">
                            Annulation non-remboursable
                              <FontAwesomeIcon id="arrow-addAnnounce"  icon={faAngleDown} />
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Manuel</DropdownItem>
                              <DropdownItem name="transmission" onClick={e=>{this.getData_dropDown.bind(this)(e)}}>Automatique</DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                      </Col>
                    </Row>
                    
                    <Row className="second-Row">
                      <Col sm="6">
                      <p>
                        Vous pouvez choisir un ou plusieurs mode de tarification
                        dans la même devise
                      </p>
                      </Col>
                      <Col sm="6">
                      <label>Taux de remboursement</label><input type="number" min="1" defaultValue = "50"  className="price-input-announce ml-2" name="prix"  required/>
                      </Col>
                    </Row>
  
                    
  
  
  
  
                    <div className="line-after-path second-Row"></div>
  
  
                    <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Je confirme que toutes les informations déclarées sont correctes,j'assume toute déclaration (Champ Obligatoie)</Label></FormGroup>
                    <FormGroup check className="check-box form-check-equipement"><Label check><Input type="checkbox" />Je souhaite vérifier mon annonce afin de bénificier des avantages de la platforme Ghurfaty (Badges,"Vérifié",Code Promo..)</Label></FormGroup>
  
                    <div className="buttons-details-announces">
                    <Button className=" button-add-moule retour-button"><FontAwesomeIcon id="arrow-retour"  icon={faAngleLeft} />Retour</Button>
                    <Button className=" button-add-moule suivant-button" onClick={this.toogleClosePhotos.bind(this)}>Suivant<FontAwesomeIcon id="arrow-suivant"  icon={faAngleRight} /></Button>
                    </div>
  
                  </Form>
                  </div>
                </Container>
              </ModalBody>
            </Modal>
            <Modal isOpen={this.props.addCarPh} toggle={this.toogleClosePhotos}  className="modal-width-images-announce">
        <nav className="nav-windows-addanounce">
        <button className="close-heberg"  onClick={this.toogleClosePhotos} >
          <span>X</span>
        </button>
        <div className="title-announce" >
          Nouvelle Annonce Location
        </div>
        </nav>

        <div className="path-heberg">
          <div className="item-path-hebrg" >

          <div className="number-path">
            <span className="number-path-value">1</span>
          </div>

          <span className="name-path" >
              Détails
              <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

          </span>

          </div>

          <div className="item-path-hebrg" style={{backgroundColor:"#37296a"}}>

             <div className="number-path" style={{backgroundColor:"white"}} >
               <span className="number-path-value" style={{color:"#37296a"}} >2</span>
             </div>

            <span className="name-path" style={{color:"white"}}>
                Photos
                <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

            </span>

         </div>

         <div className="item-path-hebrg">

             <div className="number-path">
               <span className="number-path-value">3</span>
             </div>

            <span className="name-path last-path">
                Agenda
                <FontAwesomeIcon className="icon-path"  icon={faAngleRight} />

            </span>
         </div>
        </div>

        <ModalBody style={{marginTop:"100px"}}>
          <Container>
            <Row>
              <Col md="7" style={{paddingRight: "0px"}}>
                <div className="test" style={{width:"100%",height:"400px"}}>
                  {
                    imag0 &&
                    <>
                      <img src={this.state.imgUrl[0]} className="img-add-ann" alt=""/>
                    </>
                  }

                 {
                    !imag0 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann" alt=""/>
                    </>
                  }

                </div>
              </Col>

              <Col md="5">

                <Row className="row-half-height">
                  <Col sm="6" className="padding0 pdt">
                  {
                    imag1 &&
                    <>
                      <img src={this.state.imgUrl[1]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag1 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                    
                  </Col>

                  <Col sm="6" className="padding0 pdt">
                  {
                    imag2 &&
                    <>
                      <img src={this.state.imgUrl[2]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag2 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                    
                  </Col>
                </Row>
                
                <Row className="row-half-height">
                <Col sm="6" className="last-child-image padding0 pdt">
                {
                    imag3 &&
                    <>
                      <img src={this.state.imgUrl[3]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag3 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                  
                  </Col>
                <Col sm="6" className="last-child-image padding0 pdt">
                {
                    imag4 &&
                    <>
                      <img src={this.state.imgUrl[4]} className="img-add-ann-small" alt=""/>
                    </>
                  }

                 {
                    !imag4 &&
                    <>
                      <img src="/imgs/announces/firstAnn.png" className="img-add-ann-small" alt=""/>
                    </>
                  }                   </Col>
                </Row>

              </Col>

            </Row>

            <center className="files-upload-btn">

            <form  enctype="multipart/form-data">

               <label for='upload-photo' className="button-add-moule add-imgs-button" > <span id="ajouter-text"><FontAwesomeIcon  icon={faPlus} />Ajouter des photos</span></label>
               {this.state.imgUrl.length >= 5 && <p style={{color:"red"}}>Max 5 photos</p>}
               <input type="file" name="myImage[]" id="upload-photo" disabled={this.state.imgUrl.length >= 5}
                onChange={this.onChangeUpload.bind(this)} 
               />
               {/* <input type="text" name="imageUrl" placeholder="image url" /> */}

            </form>
            </center>

            <br/> <br/>
            <h6 style={{color:"rgb(119, 113, 113)"}}>Ps : Vous pouvez télecharger jusqu'a 4 photos a la fois ,sous formats JPEG,PNG,BMP ou TIFF</h6>
            <Row>
              <div className="buttons-add-announce-photos">
                <Button className=" button-add-moule retour-button" onClick={this.retourAddHeberg}><FontAwesomeIcon id="arrow-retour"  icon={faAngleLeft} />Retour</Button>
                <Button className=" button-add-moule suivant-button" 
                onClick={this.postAnnounceCar.bind(this)}
                >Valider<FontAwesomeIcon id="arrow-suivant"  icon={faAngleRight} /></Button>
              </div>
            </Row>
          </Container>
        </ModalBody>
        </Modal>
            </>
         );
    }
}
 


function mapStateToProps(state) {
  return {
    
    addCar: state.modal.addCar,
    ownerId : state.user.user._id,
    addCarPh : state.modal.addCarPh,
    addTransfert : state.modal.addTransfert

  }
}
//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(AddTransfertAnnounce);